export default __webpack_public_path__ + "static/media/stamping.c248d340.svg";